/* eslint-disable no-console */
import { Helmet } from "react-helmet-async";
import { Route, Routes, Navigate } from "react-router-dom";
import { Loader, PrivateRoute, FichaEdificioInventario, VideoIntro } from "./components";
import { ROLES } from "./constants/roles";
import { useAuthContext } from "./context/auth";
import AuthCallback from "./context/AuthCallback";
import {
  Admin,
  Api,
  CalculadorComisionEdificio,
  CargarCliente,
  CargarEdificio,
  CargarFactura,
  CargarIntermediario,
  CargarOportunidad,
  CarteleriaPage,
  Categoria,
  CategoriaAutomotriz,
  CategoriaDelivery,
  CategoriaFastFood,
  CategoriaSmartphones,
  CategoriaInversiones,
  CategoriaMascotas,
  CategoriaPerfumes,
  CategoriaRetail,
  CategoriaTelcos,
  CategoriaTransporte,
  CategoriaVacaciones,
  CategoriaVestimenta,
  ClientesCRM,
  ClientesCartera,
  CotizadorProgrammatic,
  CotizadorProgrammaticEditar,
  ER,
  Edificios,
  FacturasEjecutivo,
  GaleriaPage,
  GestionActivosPage,
  GestionEmpleados,
  Home,
  InventarioNuevo,
  InvestigacionIpsos,
  SimuladorImpacto,
  Landing,
  LandingTD,
  ListadoB2Bnuevo,
  ListadoCotizaciones,
  ListadoVetos,
  Login,
  Mapa,
  MapaCalor,
  Mediakit,
  MediakitEdificios,
  MediakitEdificiosFullCbre,
  NotFound,
  Oportunidad,
  OportunidadFactura,
  Perfil,
  PortafolioFichaEdificios,
  PuntosDeVenta,
  Redirect,
  TransformacionDigital,
  TransformacionDigitalVentas,
  Usuarios,
  VentasBTLpage,
  VentasDetalle,
  VentasEjecutivo,
  VentasEjecutivoV2,
  VentasFactura,
  VentasProyeccion,
  VentasRegionReciente,
} from "./pages";
import MediakitEdificiosFull from "./pages/MediakitEdificiosFull";

const App = () => {
  const { session, pais, isLoading } = useAuthContext();

  const getMetaData = () => {
    if (pais === "Perú") {
      return {
        title: "Conectamos Marcas con Audiencias Premium",
        description: "Conectamos marcas y audiencias de manera eficiente.",
        canonical: "https://visiona.pe",
        hreflang: [
          { hreflang: "es-PE", href: "https://visiona.pe" },
          { hreflang: "es-CL", href: "https://wecast.cl" },
        ],
      };
    } else if (pais === "Chile") {
      return {
        title: "Conectamos Marcas con Audiencias Premium",
        description: "Conectamos marcas y audiencias de manera eficiente.",
        canonical: "https://wecast.cl",
        hreflang: [
          { hreflang: "es-PE", href: "https://visiona.pe" },
          { hreflang: "es-CL", href: "https://wecast.cl" },
        ],
      };
    } else {
      // Por defecto (si el país no está definido)
      return {
        title: "Conectamos Marcas con Audiencias Premium",
        description: "Conectamos marcas y audiencias de manera eficiente.",
        canonical: "https://visiona.pe",
        hreflang: [
          { hreflang: "es-PE", href: "https://visiona.pe" },
          { hreflang: "es-CL", href: "https://wecast.cl" },
        ],
      };
    }
  };

  const getIntroComponent = () => {
    if (pais === "Chile") {
      return <VideoIntro />;
    }
    return <NotFound />; // Or <Navigate to="/" replace /> if preferred
  };

  const { title, description, canonical, hreflang } = getMetaData();

  if (isLoading || session === undefined) return <Loader fullPage />;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        {hreflang.map((link) => (
          <link key={link.hreflang} rel="alternate" hreflang={link.hreflang} href={link.href} />
        ))}
      </Helmet>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/auth/confirm" element={<AuthCallback />} />
        <Route path="/bitcoinapi" element={<Api />} />
        <Route path="/categorias/automotriz" element={<CategoriaAutomotriz />} />
        <Route path="/categorias/fastfood" element={<CategoriaFastFood />} />
        <Route path="/categorias/delivery" element={<CategoriaDelivery />} />
        <Route path="/categorias/smartphones" element={<CategoriaSmartphones />} />
        <Route path="/categorias/inversiones" element={<CategoriaInversiones />} />
        <Route path="/categorias/mascotas" element={<CategoriaMascotas />} />
        <Route path="/categorias/perfumes" element={<CategoriaPerfumes />} />
        <Route path="/categorias/retail" element={<CategoriaRetail />} />
        <Route path="/categorias/telcos" element={<CategoriaTelcos />} />
        <Route path="/categorias/transporte" element={<CategoriaTransporte />} />
        <Route path="/categorias/vacaciones" element={<CategoriaVacaciones />} />
        <Route path="/categorias/vestimenta" element={<CategoriaVestimenta />} />
        <Route path="/edificios" element={<MediakitEdificios />} />
        <Route path="/ficha-edificio/:id" element={<FichaEdificioInventario />} />
        <Route path="/galeria" element={<GaleriaPage />} />
        <Route path="/intro" element={getIntroComponent()} />
        <Route path="/inventario" element={<InventarioNuevo />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/listadoempresas" element={<ListadoB2Bnuevo />} />
        <Route path="/listadovetos" element={<ListadoVetos />} />
        <Route path="/mapa" element={<Mapa />} />
        <Route path="/mediakit" element={<Mediakit />} />
        <Route path="/mediakit-edificios-full" element={<MediakitEdificiosFull />} />
        <Route path="/mediakit-edificios-full-cbre" element={<MediakitEdificiosFullCbre />} />
        <Route path="/investigacion-ipsos" element={<InvestigacionIpsos />} />
        <Route path="/simulador-impacto" element={<SimuladorImpacto />} />
        <Route path="/portafolio" element={<PortafolioFichaEdificios />} />
        <Route path="/puntosdeventa" element={<PuntosDeVenta />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/td" element={<LandingTD />} />
        <Route path="/transformacion-digital" element={<TransformacionDigital />} />
        <Route path="/transformacion-digital-ventas" element={<TransformacionDigitalVentas />} />
        <Route path="/carteleriiaa" element={<CarteleriaPage />} />

        {session !== null ? (
          <>
            <Route
              path="/admin"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.ADMINISTRATIVO,
                    ROLES.AGENCIA,
                    ROLES.BOARD,
                    ROLES.COMERCIAL,
                    ROLES.CONTABLE,
                    ROLES.EDIFICIO,
                    ROLES.GERENCIA,
                    ROLES.INFRAESTRUCTURA,
                    ROLES.INVERSOR,
                    ROLES.SUPERADMIN,
                    ROLES.CLIENTE,
                  ]}
                >
                  <Admin />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/er"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.BOARD,
                    ROLES.CONTABLE,
                    ROLES.ADMINISTRATIVO,
                    ROLES.INVERSOR,
                  ]}
                >
                  <ER />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cargar-cliente"
              element={
                <PrivateRoute
                  allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.BOARD, ROLES.INVERSOR]}
                >
                  <CargarCliente />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cargar-factura"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL]}>
                  <CargarFactura />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cargar-intermediario"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA]}>
                  <CargarIntermediario />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cargar-oportunidad"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL]}>
                  <CargarOportunidad />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cargar-edificio"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.ADMINISTRATIVO]}>
                  <CargarEdificio />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/factura/:oportunidadId"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO]}>
                  <OportunidadFactura />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/oportunidades/editar/:oportunidadId"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO]}>
                  <Oportunidad />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/informes-comision"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.ADMINISTRATIVO,
                    ROLES.COMERCIAL,
                    ROLES.CONTABLE,
                    ROLES.EDIFICIO,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <CalculadorComisionEdificio />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/online-cotizador"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.AGENCIA,
                    ROLES.CLIENTE,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <CotizadorProgrammatic />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/carteleriiaa"
              element={
                <PrivateRoute
                  allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO, ROLES.BOARD]}
                >
                  <CarteleriaPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/online-cotizador/editar/:id"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL]}>
                  <CotizadorProgrammaticEditar />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/ventas-BTL"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL]}>
                  <VentasBTLpage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/perfil"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.COMERCIAL, ROLES.GERENCIA]}>
                  <Perfil />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/usuarios"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <Usuarios />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/ventas-detalle"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <VentasDetalle />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/ventas-facturas"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.CONTABLE,
                    ROLES.INVERSOR,
                  ]}
                >
                  <VentasFactura />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/ventas-proyeccion"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <VentasProyeccion />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/mis-ventas"
              element={
                <PrivateRoute
                  allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.BOARD, ROLES.INVERSOR]}
                >
                  <VentasEjecutivoV2 />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/mis-ventas-baca"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.BOARD]}>
                  <VentasEjecutivo />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/mapa-calor"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL]}>
                  <MapaCalor />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/gestion-activos"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.BOARD, ROLES.ADMINISTRATIVO]}>
                  <GestionActivosPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/mis-facturas"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.INVERSOR,
                  ]}
                >
                  <FacturasEjecutivo />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/ventas-region"
              element={
                <PrivateRoute
                  allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.BOARD]}
                  allowedIds={[1, 4, 7, 306, 749, 750, 751, 752]}
                >
                  <VentasRegionReciente />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/edificios"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.ADMINISTRATIVO,
                    ROLES.BOARD,
                    ROLES.INFRAESTRUCTURA,
                  ]}
                >
                  <Edificios />
                </PrivateRoute>
              }
            />
            <Route
              path="/categorias"
              element={
                <PrivateRoute
                  allowedRoles={[
                    ROLES.SUPERADMIN,
                    ROLES.GERENCIA,
                    ROLES.COMERCIAL,
                    ROLES.AGENCIA,
                    ROLES.CLIENTE,
                    ROLES.BOARD,
                    ROLES.EDIFICIO,
                  ]}
                >
                  <Categoria />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/cotizaciones"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN]}>
                  <ListadoCotizaciones />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/clientes"
              element={
                <PrivateRoute allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.BOARD]}>
                  <ClientesCRM />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/clientes-cartera"
              element={
                <PrivateRoute
                  allowedRoles={[ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO, ROLES.BOARD]}
                >
                  <ClientesCartera />
                </PrivateRoute>
              }
            />
            <Route path="/login" element={<Navigate to="/admin" replace />} />
            <Route
              path="/admin/gestion-empleados"
              element={
                <PrivateRoute allowedRoles={[ROLES.GERENCIA, ROLES.ADMINISTRATIVO]}>
                  <GestionEmpleados />
                </PrivateRoute>
              }
            />
          </>
        ) : (
          <>
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
          </>
        )}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
